import { getStore } from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';

function hasPreloadedAllApps(): boolean {
    const { appsPreloaded } = getStore();
    return Object.keys(appsPreloaded).every(app => appsPreloaded[app]);
}

export function canPreload(): boolean {
    // The reason we disable for IE is that in the past we have seen issues
    // where adding IFrame in DOM for prefetching causes severe performance degredation.
    // To be safe we disabled prefetching for IE.
    return !hasPreloadedAllApps() && isFeatureEnabled('doc-SxS-Wac-prefetchStaticResources');
}
